module.exports = __webpack_public_path__ + "static/media/A30.bcd5b2f9.png";